import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import UXDesigns from "./pages/UXDesigns";
import LogoGallery from "./pages/LogoGallery";
import FlyerGallery from "./pages/FlyerGallery";
import MobileAppGallery from "./pages/MobileAppGallery";
import WebDevelopment from "./pages/WebDevelopment";
import Navigation from "./components/Navigation";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <div className="dark min-h-screen">
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Navigation />
            <main className="pt-16">
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/ux-designs" element={<UXDesigns />} />
                <Route path="/logo-designs" element={<LogoGallery />} />
                <Route path="/flyer-designs" element={<FlyerGallery />} />
                <Route path="/mobile-app-designs" element={<MobileAppGallery />} />
                <Route path="/web-development" element={<WebDevelopment />} />
              </Routes>
            </main>
          </BrowserRouter>
        </div>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;